export const WORKSPACE_PLANS_QUERY_KEY = ["workspace-plans"] as const;
export const WORKSPACE_SUBSCRIPTION_QUERY_KEY = ["workspace-subscription"] as const;
export const WORKSPACE_STORAGE_USAGE_QUERY_KEY = ["workspace-storage-usage"] as const;
